module.exports = __webpack_public_path__ + "static/media/eye-purple.8a2ef9c0.svg";